<template>
  <div class="cupsExpend">
    <div>
      <el-radio-group v-model="conditions" @change="tabConditions">
        <el-radio-button label="m">按月</el-radio-button>
        <el-radio-button label="y">按年</el-radio-button>
      </el-radio-group>
    </div>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="月份区间" label-width="70px" v-if="conditions === 'm'">
        <el-date-picker
            @input="search"
            v-model="searchForm.monthTime"
            value-format="yyyy-MM-dd"
            type="monthrange"
            style="width: 220px"
            unlink-panels
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="年份区间" label-width="70px" v-if="conditions === 'y'">
        <el-date-picker
            @input="search"
            v-model="searchForm.startYear"
            type="year"
            value-format="yyyy"
            style="width: 220px"
            placeholder="开始年份"
            unlink-panels>
        </el-date-picker>
        -
        <el-date-picker
            @input="search"
            v-model="searchForm.endYear"
            type="year"
            style="width: 220px"
            value-format="yyyy"
            unlink-panels
            placeholder="结束年份">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="代理商" label-width="60px">
        <DicInput @fieldId="fieldId($event,'operatorId')" :dicType="6"></DicInput>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <!--      <el-button type="warning" style="float: right" @click="viewList">查看表格<i class="el-icon-view el-icon&#45;&#45;right"></i>-->
      <!--      </el-button>-->
    </div>
    <div ref="mis4" style="width:100%;height:650px;"></div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import echarts from 'echarts/lib/echarts'
// // 再引入你需要使用的图表类型，标题，提示信息等
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/aria'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import {getDay} from "@/service/common";
import DicInput from "@/components/DicInput";
export default {
  name: "cupsExpend",
  data() {
    return {
      tableData: [],
      searchForm: {
        monthTime: [],
        startYear: '2021',
        endYear: '2022',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      conditions: 'm',
    }
  },
  components: {
    Pagination,
    DicInput
  },
  methods: {
    // -------------------查询条件/清空-------------------
    search() {
      this.tabConditions()
    },
    clear() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.searchForm = {
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
        operatorId:'',
      }
      this.init()
    },
    // viewList() {
    //   this.$router.push('/recipeStatistics/salesList')
    // },
    echarts(arrdata,groups) {
      this.mis4 = echarts.init(this.$refs.mis4);
      this.mis4.setOption(
          {
            legend: {
              data: arrdata.title
            },
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: this.unique(arrdata.date)
            },
            yAxis: {
              type: 'value'
            },
            series:groups
          }
      )
    },
    tabConditions() {
      let url = ''
      let data = {}
      let start, end
      if (this.conditions === 'm') {
        url = '/Statistic/PFStatistic/GetMonthCupStatistics'
        start = this.searchForm.monthTime[0]
        end = this.searchForm.monthTime[1]
        data = {
          start: start,
          end: end,
          operatorId:this.searchForm.operatorId,
        }
      } else {
        url = '/Statistic/PFStatistic/GetYearCupStatistics'
        start = this.searchForm.startYear
        end = this.searchForm.endYear
        data = {
          yearStart: start,
          yearEnd: end,
          operatorId:this.searchForm.operatorId,
        }
      }
      this.init(url, data)
    },
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    // list
    init(url, data) {
      this.axios
          .get(url, {params: data})
          .then((res) => {
            this.tableData = res
            let arrdata = {
              date: [],
              usedAmount:[],
              title:[],
            }
            let groups=[];
            this.tableData.forEach(item => {
              let target=null;
              for(let i in groups){
                if(groups[i].name==item.cupTypeName) {
                  target = groups[i];
                  break;
                }
              }
              if(target==null){
                arrdata.title.push(item.cupTypeName)
                groups.push({
                  name: item.cupTypeName,
                  type: 'line',
                  stack: '总量',
                  data: [item.usedAmount]
                });
              }
              else{
                target.data.push(item.usedAmount);
              }
              switch (this.conditions) {
                case "m":
                  arrdata.date.push(item.year + '-' + item.month)
                  break;
                default :
                  arrdata.date.push(item.year)
              }
            })
            this.echarts(arrdata,groups)
          })
    },
    unique(arr) { // 数组去重
      return Array.from(new Set(arr))
    },
  },
  mounted() {
    //
    this.tabConditions()
  }
}
</script>

<style lang="scss" scoped>
.cupsExpend {
  text-align: start;
  min-height: 800px;

  & > div:nth-child(1) {
    margin-bottom: 20px;

    .el-button {
      box-shadow: 0 4px 8px #FFE0BA;
    }
  }

  .decBox {
    padding-right: 20px;

    i {
      font-style: normal;
    }
  }

  .el-form {
    display: flex;
    flex-wrap: wrap;
  }

  .doctorDetails {
    .titleName {
      font-weight: bold;
      padding-right: 10px;
    }

    .detailsLine {
      padding-bottom: 20px;
    }

    .tagList {
      margin-right: 10px;
    }
  }
}
</style>